import {calculateArrowPointOnLineString} from './calculateArrowPointOnLineString.js';

export function calculateArrowPointOnMultiLineString(
    linecoordinates,
    placement = 'end',
    toRight = true,
    foreachSegment = false
) {
    var points = [];
    var angles = [];
    for (let i = 0; i < linecoordinates.length; i++) {
        const line = linecoordinates[i];
        const result = calculateArrowPointOnLineString(
            line,
            placement,
            toRight,
            foreachSegment
        );

        points = points.concat(result.points);
        angles = angles.concat(result.angles);
    }
    return {points: points, angles: angles};
}
